'use strict';

/**
 * @type {Object}
 * @property {Object} NOT_FOUND generic not found error code for whole auth service
 */
var serviceErrorCodes = Object.freeze({
    NOT_FOUND               : 'authService.notFound',
    STEAM_ERROR             : 'authService.steamError',
    TOKEN_EXPIRED           : 'authService.tokenExpired',
    INVALID_TOKEN           : 'authService.invalidToken',
    INVALID_TOKEN_FORMAT    : 'authService.invalidTokenFormat',
    USER_BANNED             : 'authService.userBanned',
    PASSWORD_EXPIRED        : 'authService.passwordExpired',
    NOT_ACTIVE              : 'authService.notActive',
    TWO_FACTOR_AUTH_DISABLED: 'authService.twoFactorAuthDisabled',
    PSN_ERROR               : 'authService.psnError',
    RAIL_ERROR              : 'authService.railError',
});

module.exports = serviceErrorCodes;